export const project = ['游泳','射箭','田径','羽毛球','棒垒球','篮球','拳击','霹雳舞','皮划艇','板球','自行车','马术',
'击剑','足球','高尔夫','体操','手球','曲棍球','棍网球','柔道','空手道','现代五项','赛艇','橄榄球','帆船','射击','滑板','攀岩','壁球','冲浪','乒乓球',
'跆拳道','网球','铁人三项','排球','举重','摔跤','冬季两项','雪车','冰壶','冰球','雪橇','滑冰','滑雪','其它项目']